export async function hmacSha256Hex(secret: string, message: string): Promise<string> {
  const encoder = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw',
    encoder.encode(secret),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign'],
  );
  const signature = await crypto.subtle.sign('HMAC', key, encoder.encode(message));
  const bytes = new Uint8Array(signature);
  let hex = '';
  for (let i = 0; i < bytes.length; i += 1) {
    hex += (`00${bytes[i].toString(16)}`).slice(-2);
  }
  return hex;
}

export async function generateCustomerAccountCode(
  secretKey: string,
  customerId: string,
  name: string | null | undefined,
  extraInfo: string | null | undefined,
  timestamp: number,
): Promise<string> {
  const nameValue = name ?? '';
  const extraInfoValue = extraInfo ?? '';
  const msg = `${customerId}${nameValue}${extraInfoValue}${timestamp}`;
  return hmacSha256Hex(secretKey, msg);
}
